export const MilestoneOptions = [
    { value: 'CHALLENGE', label: 'Challenge', types: [
        { value: 'join', label: 'Joins', tiers: [
            {award: 1, image: "image/Milestones_Joined_1.png" },
            {award: 5, image: "image/Milestones_Joined_5.png" },
            {award: 10, image: "image/Milestones_Joined_10.png" },
            {award: 20, image: "image/Milestones_Joined_20.png" },
        ]},
        { value: 'finish', label: 'Finishes', tiers: [
            {award: 1, image: "image/Milestones_Completed_1.png" },
            {award: 5, image: "image/Milestones_Completed_5.png" },
            {award: 10, image: "image/Milestones_Completed_10.png" },
            {award: 20, image: "image/Milestones_Completed_20.png" },
        ]},
    ]},

    { value: 'STAND', label: 'Stand', types: [
        { value: 'stand', label: 'Standing', tiers: [
            { award: 1, image: "image/Stand Milestones_1.png" },
            { award: 5, image: "image/Stand Milestones_5.png" },
            { award: 10, image: "image/Stand Milestones_10.png" },
            { award: 20, image: "image/Stand Milestones_20.png" },
            { award: 30, image: "image/Stand Milestones_30.png" },
        ]},
    ]},

    { value: 'CHARITY', label: 'Charity', types: [
        { value: 'donation_earned', label: 'Donation Earned', tiers: [
            { award: 1, image: "image/Charity Milestones_1.png" },
            { award: 5, image: "image/Charity Milestones_5.png" },
            { award: 10, image: "image/Charity Milestones_10.png" },
            { award: 20, image: "image/Charity Milestones_20.png" },
        ]},
        /*
            { value: 'stand_cause', label: 'Stand for a Cause', tiers: [
                { award: 1, image: 'image/Charity_Milestones_1.png' },
                { award: 5, image: 'image/Charity_Milestones_5.png' },
                { award: 10, image: 'image/Charity_Milestones_10.png' },
            ]},
        */
    ]},

    { value: 'SOCIAL', label: 'Social', types: [
        { value: 'share', label: 'Shares', tiers: [
            { award: 1, image: "image/Social_Share_1.png" },
            { award: 5, image: "image/Social_Share_5.png" },
            { award: 10, image: "image/Social_Share_10.png" },
            { award: 20, image: "image/Social_Share_20.png" },
            { award: 50, image: "image/Social_Share_50.png" },
        ]},
        { value: 'invite', label: 'Invites', tiers: [
            { award: 1, image: "image/Social_Invite_1.png" },
            { award: 5, image: "image/Social_Invite_5.png" },
            { award: 10, image: "image/Social_Invite_10.png" },
            { award: 20, image: "image/Social_Invite_20.png" },
            { award: 30, image: "image/Social_Invite_30.png" },
            { award: 50, image: "image/Social_Invite_50.png" },
        ]},
    ]},
];

export function getTypes(category) {
    const categoryObj = MilestoneOptions.find(option => option.value === category);
    return categoryObj ? categoryObj.types : [];
}

export function findType(typeValue) {
    for (const category of MilestoneOptions) {
        const typeObj = category.types.find(type => type.value === typeValue);
        if (typeObj) {
            return typeObj;
        }
    }
    return null;
}

export function tiersInsideTypes(typeValue) {
    const typeObj = findType(typeValue);
    return typeObj ? typeObj.tiers : [];
}

export function findTier(typeValue, award) {
    return tiersInsideTypes(typeValue).find(tier => String(tier.award) === String(award)) || null;
}
